/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../CSS/index.css';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter, StyledHomepage } from '../../../commons/styles/layout';
import { API_MODULES, IPAddress } from '../../../commons/api';
import { useNavigate } from "react-router-dom";

import {
  Form,
  Input,
  message,
  Button,
  Tabs,
  Drawer,
  Upload,
  Select,
  Modal
} from 'antd';
import {
  SearchOutlined,
  EditOutlined,
  UploadOutlined,
  DownloadOutlined,
  PlusOutlined
} from '@ant-design/icons';
import translation from '../Utils/translation';

import {
  UpdateMasters,
  CreateMasters,
  getModulesFileDownloadName,
  getDeviceTypeFileDownloadName
} from '../APICalls';
// import ParameterAlias from './RubusMaster/ParameterAlias';
// import ColorCodes from './RubusMaster/ColorCodes';
// import { useNavigate } from 'react-router-dom';
const ApiList = {
  CreateModule: `${API_MODULES.ModulesCreate}`,
  UpdateModule: `${API_MODULES.ModulesUpdate}`
};
const { TabPane } = Tabs;
const { Option } = Select;

const Mod = (props) => {
  const [formObject, setFormObject] = useState({});
  const [list, setList] = useState([]);
  const [visibleParent, setVisibleParent] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [fileDownloadName, setFileDownloadName] = useState('');
  const [fileDTDownloadName, setFileDTDownloadName] = useState('');
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  const hForm = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    _getList();
    // DeviceTypeApi();
    getAllDeviceTypeFileDownloadName();
    getFileDownloadName();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    // Handle translation cache updates if needed
  }, [translationCache]);

  const getAllDeviceTypeFileDownloadName = async () => {
    let fileDTDownloadName = await getDeviceTypeFileDownloadName();
    setFileDTDownloadName(fileDTDownloadName && fileDTDownloadName.file ? fileDTDownloadName.file : '');
  };


  const _getList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = '';
    url = `${API_MODULES.ModulesGet}?Status=Active&SiteId=${siteId}`;

    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const _editRecord = (record) => {
    hForm.current && hForm.current.setFieldsValue(record);
    setVisibleParent(true);
    setFormObject(record);
  };

  const OnNextClick = (record) => {
    navigate(
      `/rubus/CustomerAssetDevice/DeviceTypes/${record.Code}?AliasCode=${record.AliasCode}`
    );
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const onFinish = async () => {
    hForm.current &&
      hForm.current
        .validateFields()
        .then(async (values) => {
          let payload = {
            ...values
          };

          if (formObject && formObject.Id) {
            let UpdateResponse = await UpdateMasters(ApiList.UpdateModule, payload, formObject.Id);
            message.success(UpdateResponse && UpdateResponse.message);
          } else {
            let createResponse = await CreateMasters(ApiList.CreateModule, payload);
            if (createResponse.Id) {
              message.success(createResponse && createResponse.message);
            } else {
              message.warning(createResponse && createResponse.message);
            }

          }
          _getList();
          getFileDownloadName();
          hForm.current &&
            hForm.current.setFieldsValue({
              Code: null,
              Name: null,
              Status: 'Active'
            });
          setFormObject({});
          setVisibleParent(false);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const OpenDrawer = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        Status: 'Active'
      });
    let formObject = {
      Code: null,
      Name: null,
      Status: 'Active'
    };
    setVisibleParent(true);
    setFormObject(formObject);
  };

  const onClose = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        Status: 'Active'
      });
    setVisibleParent(false);
    setFormObject({});
  };

  const getFileDownloadName = async () => {
    let fileDownloadName = await getModulesFileDownloadName();
    setFileDownloadName(fileDownloadName && fileDownloadName.file ? fileDownloadName.file : '');
  };

  const handleChange = async (value, key) => {
    let newFormObject = {
      ...formObject,
      [key]: value
    };
    setFormObject(newFormObject);
  };

  const handleModalConfirm = () => {
    setModalVisible(false);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  let colum = [
    { key: 'S No', value: 'S No' },
    { key: 'Module Code', value: 'Code' },
    { key: 'Module Name', value: 'Name' },
    { key: 'Status', value: 'Status' }
  ];

  let columns =
    colum && Array.isArray(colum)
      ? colum
        .map((field) => {
          return {
            title: field.key,
            dataIndex: field.value,
            key: field.value,
            ...getColumnSearchProps(field.value)
          };
        })
      : [];

  let finalColumns = [
    ...columns,
    {
      title: translation(translationCache, 'Actions'),
      dataIndex: 'Actions',
      key: 'Actions',
      render: (_text, record) => (
        <span>
          <Button
            type='primary'
            icon={<EditOutlined />}
            onClick={() => _editRecord(record)}
            
          />
          <Button
            onClick={() => OnNextClick(record)}
            
            type="primary"
            style={{ marginLeft: '10px' }}
          >
            {translation(translationCache, 'Next')}
          </Button>
        </span>
      )
    }
  ];

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  let searchInput;
  return (
    <StyledHomepage>
      <Modal
        className="ServerRegistrationModal"
        closable={false}
        title={null}
        visible={modalVisible}
        onOk={handleModalConfirm}
        cancelText={translation(translationCache, 'No')}
        okText={translation(translationCache, 'Yes')}
        onCancel={handleModalCancel}
      >
        Are you sure that you want to upload all masters
      </Modal>
      <Tabs
        tabPosition="top"
        type="card"
      >
        <TabPane tab={translation(translationCache, 'Modules')} key="Modules">
          <div style={{ display: 'flex', justifyContent: 'right', padding: '20px' }}>
            <Button type="primary" style={{ marginRight: '10px' }}>
              <Upload
                multiple={false}
                style={{ marginRight: '10px', color: 'white' }}
                onChange={(info) => {
                  if (info.file.status === 'done') {
                    message.success(info.file.response.message);
                    getAllDeviceTypeFileDownloadName();
                  } else if (info.file.status === 'error') {
                    message.error(info.file.response.message);
                  }
                }}
                action={`/api/rubusMaster/upload/deviceTypes?SiteId=${siteId}`}
                headers={{
                  Authorization: Authorization
                }}
                showUploadList={false}
              >
                <UploadOutlined
                  style={{ color: 'white', marginRight: '1px' }}
                />
                <span style={{ color: 'white', marginRight: '10px' }}>
                  {translation(translationCache, 'Upload devicetypes for all modules')}
                </span>
              </Upload>
            </Button>
            <Button type="primary" style={{ marginRight: '10px' }}>
              <a href={`${IPAddress.LOCAL}${fileDTDownloadName}`}>
                <DownloadOutlined
                  style={{ color: 'white', marginRight: '1px' }}
                />
                <span style={{ color: 'white', marginRight: '10px' }}>
                  {translation(translationCache, 'Download devicetypes for all modules')}
                </span>
              </a>
            </Button>
            <Button type="primary" style={{ marginRight: '10px' }}>
              <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
                <DownloadOutlined
                  style={{ color: 'white', marginRight: '1px' }}
                />
                <span style={{ color: 'white', marginRight: '10px' }}>
                  {translation(translationCache, 'Download')}
                </span>
              </a>
            </Button>
            <Button type='primary' style={{ marginRight: '10px' }}>
              <Upload
                multiple={false}
                style={{ marginRight: '10px', color: 'white' }}
                onChange={(info) => {
                  if (info.file.status === 'done') {
                    message.success(info.file.response.message);
                    getFileDownloadName();
                    _getList();
                  } else if (info.file.status === 'error') {
                    message.error(info.file.response.message);
                  }
                }}
                action={`/api/rubusMaster/upload/modules?SiteId=${siteId}`}
                headers={{
                  Authorization: Authorization
                }}
                showUploadList={false}
              >
                <UploadOutlined
                  style={{ color: 'white', marginRight: '1px' }}
                />
                <span style={{ color: 'white', marginRight: '10px' }}>
                  {translation(translationCache, 'Upload')}
                </span>
              </Upload>
            </Button>
            <Button type='primary' style={{ marginRight: '10px' }} onClick={OpenDrawer}>
              <PlusOutlined /> {translation(translationCache, 'Add Modules')}
            </Button>
            {list && Array.isArray(list) && list.length === 0 ? (
              <Button>
                <Upload
                  multiple={false}
                  style={{ marginLeft: '10px', color: 'white' }}
                  onChange={(info) => {
                    if (info.file.status === 'done') {
                      message.success(info.file.response.message);
                      // this.getParameterList();
                      getFileDownloadName();
                      _getList();
                    } else if (info.file.status === 'error') {
                      message.error(info.file.response.message);
                    }
                  }}
                  action={`/api/rubusMaster/upload/mastersBulkUpload?SiteId=${siteId}`}
                  headers={{
                    Authorization: Authorization
                  }}
                  showUploadList={false}
                >
                  <UploadOutlined
                    style={{ color: 'white', marginRight: '1px' }}
                  />
                  <span style={{ color: 'white', marginRight: '10px' }}>
                    {' '}
                    {translation(translationCache, 'Upload All Masters')}
                  </span>
                </Upload>
              </Button>
            ) : null}
          </div>
          <StyledTable size="small"
            rowKey={(record) => record.Id}
            columns={finalColumns}
            dataSource={list}
            pagination={
              list.length > 10
                ? {
                  pageSize: '10'
                }
                : false
            }
          />
        </TabPane>
        {/* <TabPane tab={translation(translationCache, 'Parameter Alias')} key="ParameterAlias">
          <ParameterAlias />
        </TabPane>
        <TabPane tab={translation(translationCache, 'Color Codes')} key="ColorCodes">
          <ColorCodes />
        </TabPane> */}
      </Tabs>
      <Drawer
        title={formObject && formObject.Id ? translation(translationCache, 'Edit Modules') : translation(translationCache, 'Add Modules')}
        // width={window.innerWidth > 768 ? 720 : window.innerWidth}
        onClose={onClose}
        open={visibleParent}
        width={600}
        placement="right"
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          // theme={themeSettings}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject}
          onFinish={onFinish}>
          <Form.Item
            name="Code"
            label={translation(translationCache, 'Module Code')}
            rules={[
              {
                required: true,
                message: translation(translationCache, 'Please enter Module Code')
              }
            ]}
          >
            <Input
              disabled={formObject.Id}
              placeholder={translation(translationCache, 'Please enter Module Code')}
              onChange={(e) => handleChange(e.target.value, 'Code')}
            />
          </Form.Item>
          <Form.Item
            name="Name"
            label={translation(translationCache, 'Module Name')}
            rules={[
              {
                required: true,
                message: translation(translationCache, 'Please enter Module Name')
              }
            ]}
          >
            <Input
              placeholder={translation(translationCache, 'Please enter Module Name')}
              onChange={(e) => handleChange(e.target.value, 'Name')}
            />
          </Form.Item>
          <Form.Item
            name="Status"
            label={translation(translationCache, 'Status')}
            rules={[
              {
                required: true,
                message: translation(translationCache, 'Please select an Status')
              }
            ]}
          >
            <Select
              placeholder={translation(translationCache, 'Please select an Status')}
              onChange={(e) => handleChange(e, 'Status')}
              allowClear
            >
              <Option value="Active">{translation(translationCache, 'Active')}</Option>
              <Option value="InActive">{translation(translationCache, 'InActive')}</Option>
            </Select>
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
            {translation(translationCache, 'Cancel')}
          </Button>
          <Button type="primary" onClick={onFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>
      </Drawer>
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache

});
export default connect(mapStateToProps)(Mod);
